/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as UnspeccedDefs from './defs.defs.js'

const $nsid = 'app.bsky.unspecced.getPostThreadOtherV2'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  anchor: /*#__PURE__*/ l.string({ format: 'at-uri' }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  thread: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ThreadItem>((() => threadItem) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** (NOTE: this endpoint is under development and WILL change without notice. Don't use it until it is moved out of `unspecced` or your application WILL break) Get additional posts under a thread e.g. replies hidden by threadgate. Based on an anchor post at any depth of the tree, returns top-level replies below that anchor. It does not include ancestors nor the anchor itself. This should be called after exhausting `app.bsky.unspecced.getPostThreadV2`. Does not require auth, but additional metadata and filtering will be applied for authed requests. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid

type ThreadItem = {
  $type?: 'app.bsky.unspecced.getPostThreadOtherV2#threadItem'
  uri: l.AtUriString

  /**
   * The nesting level of this item in the thread. Depth 0 means the anchor item. Items above have negative depths, items below have positive depths.
   */
  depth: number
  value: l.$Typed<UnspeccedDefs.ThreadItemPost> | l.Unknown$TypedObject
}

export type { ThreadItem }

const threadItem = /*#__PURE__*/ l.typedObject<ThreadItem>(
  $nsid,
  'threadItem',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    depth: /*#__PURE__*/ l.integer(),
    value: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<UnspeccedDefs.ThreadItemPost>(
          (() => UnspeccedDefs.threadItemPost) as any,
        ),
      ],
      false,
    ),
  }),
)

export { threadItem }
